import { useContext } from "react";
import RedirectCard from "./_elements/redirect-card";

import UserContext from "../services/user/user";

import cardIcon from "../assets/images/card_icon.png";
import { FormattedMessage } from "react-intl";
import Grid from "@mui/system/Unstable_Grid/Grid";

import messages_de from "../translations/de.json";
import messages_en from "../translations/en.json";
import messages_es from "../translations/es.json";
import messages_fr from "../translations/fr.json";

export default function RedirectSection() {
  const messages = {
    de: messages_de,
    en: messages_en,
    es: messages_es,
    fr: messages_fr
  };

  const { lang } = useContext(UserContext);

  const lg = 2.4;
  const md = 6;
  const sm = 6;
  const xs = 12;

  return (
    <Grid container spacing={3} style={{ marginTop: "24px" }}>
      {/* Row1 */}
      <Grid item xs={xs} sm={sm} md={md} lg={lg}>
        <RedirectCard
          url={messages[lang]["automatedTaxDetermination.url"]}
          icon={cardIcon}
          title={<FormattedMessage id="automatedTaxDetermination" />}
          // title={
          //   window.innerWidth <= 1440 && lang === "de" ? (
          //     <Ticker
          //       speed={3}
          //       mode={"smooth"}
          //       move={tile1Ticker}
          //       onFinish={() => {
          //         setTile1Ticker(false);
          //         setTimeout(() => {
          //           setTile1Ticker(true);
          //         }, 2500);
          //       }}
          //     >
          //       {({ index }) => (
          //         <>
          //           <FormattedMessage id="automatedTaxDetermination" />
          //         </>
          //       )}
          //     </Ticker>
          //   ) : (
          //     <FormattedMessage id="automatedTaxDetermination" />
          //   )
          // }
          subtitle={
            <FormattedMessage id="automatedTaxDetermination.description" />
          }
          dataTestId={"showcase_box1"}
        />
      </Grid>
      <Grid item xs={xs} sm={sm} md={md} lg={lg}>
        <RedirectCard
          url={messages[lang]["verifyVatId.url"]}
          icon={cardIcon}
          title={<FormattedMessage id="verifyVatId" />}
          subtitle={<FormattedMessage id="verifyVatId.description" />}
          dataTestId={"showcase_box5"}
        />
      </Grid>
      <Grid item xs={xs} sm={sm} md={md} lg={lg}>
        <RedirectCard
          url={messages[lang]["vatReportingToOss.url"]}
          icon={cardIcon}
          title={<FormattedMessage id="vatReportingToOss" />}
          subtitle={<FormattedMessage id="vatReportingToOss.description" />}
          dataTestId={"showcase_box2"}
        />
      </Grid>
      <Grid item xs={xs} sm={sm} md={md} lg={lg}>
        <RedirectCard
          url={messages[lang]["vatFreeEcommerce.url"]}
          icon={cardIcon}
          title={<FormattedMessage id="vatFreeEcommerce" />}
          // title={
          //   window.innerWidth <= 1440 && lang === "de" ? (
          //     <Ticker
          //       speed={3}
          //       mode={"smooth"}
          //       move={tile2Ticker}
          //       onFinish={() => {
          //         setTile2Ticker(false);
          //         setTimeout(() => {
          //           setTile2Ticker(true);
          //         }, 2500);
          //       }}
          //     >
          //       {({ index }) => (
          //         <>
          //           <FormattedMessage id="vatFreeEcommerce" />
          //         </>
          //       )}
          //     </Ticker>
          //   ) : (
          //     <FormattedMessage id="automatedTaxDetermination" />
          //   )
          // }
          subtitle={<FormattedMessage id="vatFreeEcommerce.description" />}
          dataTestId={"showcase_box3"}
        />
      </Grid>
      <Grid item xs={xs} sm={sm} md={md} lg={lg}>
        <RedirectCard
          url={messages[lang]["allCustomsTariffs.url"]}
          icon={cardIcon}
          title={<FormattedMessage id="allCustomsTariffs" />}
          subtitle={<FormattedMessage id="allCustomsTariffs.description" />}
          dataTestId={"showcase_box4"}
        />
      </Grid>
      {/* Row2 */}
      {/* <RedirectCard
        url="#"
        icon={cardIcon}
        title={<FormattedMessage id="customsTariffs" />}
        subtitle={<FormattedMessage id="customsTariffs.description" />}
      /> */}
    </Grid>
  );
}
